import React, { useState, useEffect } from "react";

import MakeDonation from "./MakeDonation";
import { useAvailableAssets } from "../hooks/query/queries";
import DonationConfirmation from "./DonationConfirmation";
import DonationComplete from "./DonationComplete";
import AuthTwoFA from "./AuthTwoFA";
import { useToast } from "../hooks/use-toast";
import { verify2FA } from "../services/digitalWalletService";
import { useAuth } from "../context/AuthContext";
import { makeDonation } from "../services/settingsService";
import { useQueryClient } from "@tanstack/react-query";
export default function MakeDonationParent({ data }) {
  const queryClient = useQueryClient();
  const [showQuote, setShowQuote] = useState(false);
  const [showAuth, setShowAuth] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [hasBeenSetUp, setHasBeenSetUp] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [loadingDonate, setLoadingDonate] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [childAmount, setChildAmount] = useState(null);
  const [isEnabled, setIsEnabled] = useState(false);
  const { userProfile, settings, updateSettings } = useAuth();
  const userId = userProfile?._id;

  const investArray = {
    id: userId,
  };

  const { data: tradingAssets, isLoading: LoadingAssets } = useAvailableAssets({
    investArray,
  });

  const { toast } = useToast();

  const donateArray = {
    userId: userId,
    recipient: data?.id,
    asset: selectedAsset?.assetId,
    amount: childAmount,
  };

  useEffect(() => {
    setIsEnabled(settings?.security?.twoFactorAuth?.enabled);
  }, [settings]);

  const donate = async () => {
    try {
      const result = await makeDonation(donateArray);
      return result;
    } catch (error) {
    } finally {
      setLoadingDonate(false);
      handleConfirm();
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    }
  };

  const handleContinue = () => {
    setShowQuote(true);
  };
  const handleBank = () => {
    setShowQuote(false);
  };
  const handleVerify = async (token) => {
    setLoadingDonate(true);
    try {
      const twoFAdata = {
        token: token,
      };

      const verifiedTwoFA = await verify2FA(twoFAdata);
      if (verifiedTwoFA) {
        updateSettings(verifiedTwoFA);
        toast({
          description: `2FA ${isEnabled ? "verified" : "enabled"} Successfully`,
          variant: "eighty",
        });
        donate();
      }
    } catch (error) {
      toast({
        description: `${error.message}`,
        variant: "eighty",
      });
      setIsVerifying(false);
    }
  };

  const handleConfirm = () => {
    setSelectedAsset(null);
    setChildAmount(null);
    setShowAuth(false);
    setShowQuote(false);
    setShowSuccess(true);
  };
  const twoFactor = () => {
    if (hasBeenSetUp) {
      handleConfirm();
    }
    if (!hasBeenSetUp) {
      setShowQuote(false);
      setShowAuth(true);
    }
  };
  const handleBackfromTwoFA = () => {
    setShowAuth(false);
    setShowQuote(true);
  };
  const handleSetup = () => {
    setHasBeenSetUp(true);
  };
  const handleDone = () => {
    setShowAuth(false);
    setShowQuote(false);
    setShowSuccess(false);
    setIsVerifying(false);
  };
  return (
    <>
      {!showQuote && !showSuccess && !showAuth && (
        <MakeDonation
          organisation={data}
          tradingAssets={tradingAssets}
          selectedAsset={selectedAsset}
          setSelectedAsset={setSelectedAsset}
          childAmount={childAmount}
          setChildAmount={setChildAmount}
          LoadingAssets={LoadingAssets}
          onContinue={handleContinue}
        />
      )}
      {showQuote && !showSuccess && !showAuth && (
        <DonationConfirmation
          onBack={handleBank}
          onConfirm={twoFactor}
          setUp={handleSetup}
          customQuote={donateArray}
          asset={selectedAsset}
          orgName={data?.organisation_info?.org_name}
        />
      )}
      {showAuth === true && !showSuccess && !showQuote && (
        <div className="flex justify-center mt-12 px-4 md:px-16 lg:px-32">
          <AuthTwoFA
            onVerify={handleVerify}
            onBack={handleBackfromTwoFA}
            isVerifying={isVerifying}
            setIsVerifying={setIsVerifying}
            loadingDonate={loadingDonate}
          />
        </div>
      )}
      {showSuccess && !showAuth && !showQuote && (
        <DonationComplete onDone={handleDone} />
      )}
    </>
  );
}
